import { goodPracticesToOptions } from './formatters'

export const goodPracticeListSelector = (state) => state.good_practices.list
export const goodPracticesOptionsSelector = (state) =>
  goodPracticesToOptions(goodPracticeListSelector(state))
export const goodPracticeExpiresAtSelector = (state) =>
  state.good_practices.expiresAt
